// DataTables for race results pages
// CSS is extracted by MiniCssExtractPlugin → assets/css/results.css
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';

import DataTable from 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';

document.addEventListener('DOMContentLoaded', () => {
  const content = document.querySelector('.race-content');
  if (!content) return;

  content.querySelectorAll('table').forEach((table) => {
    // Determine column indices from headers
    const headers = Array.from(table.querySelectorAll('thead th')).map((th) =>
      th.textContent.trim().toLowerCase()
    );
    const medalColIdx = headers.lastIndexOf('medal');
    const timeColIdx = headers.indexOf('course time');
    const handicapTimeIdx = headers.indexOf('handicap time');

    // Only enhance genuine results tables (opt-in via class, or recognisable
    // results columns); leave other tables (draws, fees, etc.) as plain tables.
    const isResults =
      table.classList.contains('results-table') ||
      medalColIdx >= 0 ||
      timeColIdx >= 0 ||
      handicapTimeIdx >= 0;
    if (!isResults) return;

    // Mark medal rows before DataTable init (so CSS class is preserved)
    table.querySelectorAll('tbody tr').forEach((row) => {
      if (medalColIdx >= 0) {
        const cell = row.cells[medalColIdx];
        if (cell && cell.textContent.trim() === 'Yes') {
          row.classList.add('medal-row');
        }
      }

      // Flag DNS/DNF rows (sentinel time value 2399:xx or 2400:xx)
      if (timeColIdx >= 0) {
        const t = row.cells[timeColIdx]?.textContent.trim() ?? '';
        if (/^2[34]\d{2}:/.test(t)) {
          row.classList.add('dns-row');
          // Replace sentinel with readable label
          ['course time', 'handicap time'].forEach((col) => {
            const idx = headers.indexOf(col);
            if (idx >= 0 && row.cells[idx]) {
              row.cells[idx].textContent = 'DNS/DNF';
            }
          });
        }
      }
    });

    // Wrap in responsive container
    if (!table.parentElement.classList.contains('table-responsive-results')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'table-responsive-results';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }

    // Build DOM string — include medals-toggle slot
    const domStr =
      '<"row align-items-center mb-3"' +
      '<"col-sm-auto"l>' +
      '<"col-sm-auto ms-auto d-flex align-items-center gap-2"<"medals-toggle">f>' +
      '>rtip';

    const dt = new DataTable(table, {
      responsive: true,
      pageLength: 50,
      lengthMenu: [25, 50, 100, { label: 'All', value: -1 }],
      order: [[0, 'asc']],
      dom: domStr,
      language: {
        search: '',
        searchPlaceholder: 'Search…',
        lengthMenu: 'Show _MENU_',
      },
    });

    // ── Medals-only toggle ───────────────────────────────────────────────
    const toggleSlot = table
      .closest('.table-responsive-results')
      ?.parentElement?.querySelector('.medals-toggle');
    if (toggleSlot) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn btn-sm btn-outline-secondary btn-medals-toggle';
      btn.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true" class="me-1"><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696 2.19-4.344c.197-.39.73-.39.927 0l2.19 4.344 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/></svg>Medals only';
      btn.setAttribute('aria-pressed', 'false');

      let medalsOnly = false;

      // Register a custom DataTables search function for this table
      const filterFn = function (settings) {
        // Only apply to this specific table instance
        if (settings.nTable !== table) return true;
        if (!medalsOnly) return true;
        // Get the TR node for the current row being tested
        const trNode = settings.aoData[settings._iDisplayStart]?.nTr;
        // DataTables calls the function row by row — use the built-in API
        return false; // placeholder; real filter below
      };

      btn.addEventListener('click', () => {
        medalsOnly = !medalsOnly;
        btn.setAttribute('aria-pressed', String(medalsOnly));
        btn.classList.toggle('active', medalsOnly);
        btn.classList.toggle('btn-outline-secondary', !medalsOnly);
        btn.classList.toggle('btn-gold', medalsOnly);

        // Use DataTables row().invalidate() + draw() with custom search
        dt.draw();
      });

      // Use DataTables' search API (push/pop per-instance)
      DataTable.ext.search.push(function (_settings, _data, _idx, _row, counter) {
        if (_settings.nTable !== table) return true;
        if (!medalsOnly) return true;
        const rowNode = dt.row(counter).node();
        return rowNode ? rowNode.classList.contains('medal-row') : false;
      });

      toggleSlot.appendChild(btn);
    }
  });
});
